
































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { Quote } from '@/models/quotes/Quote';
import { Logo } from '@/models/carriers/Logo';
import { SaveShipmentRequest } from '@/models/shipments/addOrEdit/requests/SaveShipmentRequest';
import { SavePendingOrderResponse } from '@/models/shipments/addOrEdit/responses/SavePendingOrderResponse';

import carrierLogoService from '@/services/CarrierLogoService';
import quoteService from '@/services/QuoteService';
import miscService from '@/services/MiscService';
import holidayService from '@/services/HolidayService';
import pendingOrderService from '@/services/PendingOrderService';
import routeService from '@/services/RouteService';
import domService from '@/services/DOMService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, authMixin, breakpointsMixin, formatMixin],
  data() {
    return {
      quote: null as Quote,
      loading: false,
      availableTabs: ['Overview'],
      currentTab: 'Overview',
      logo: new Logo('', ''),
      checked: true,
      selectedQuote: null as Quote,
      snackbar: false,
      showEmailQuotePopup: false,
      emailingQuote: false,
      emailTemplate: null,
      snackbarText: '',
      holidays: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    tabClicked(tab) {
      this.currentTab = tab;
    },
    init() {
      this.loading = true;
      this.loadingMsg = 'Loading details...';

      quoteService.getById(this.id).then((x: Quote) => {
        this.quote = x;
        this.loading = false;
      });

      holidayService.getAll().then((x) => {
        this.holidays = x;
      });
    },
    backToPrevPage() {
      miscService.goBack();
    },
    copy() {
      domService.copyToClipboard(this.id);
      this.snackbarText = `Quote number ${this.id} has been copied to the clipboard`;
      this.snackbar = true;
    },
    isHoliday(date) {
      const dateString = date.format('YYYY-MM-DD');
      return this.holidays.includes(dateString);
    },
    isWeekend(date) {
      const dayOfWeek = date.day();
      return dayOfWeek == 0 || dayOfWeek == 6;
    },
    emailQuote() {
      this.loading = true;
      this.loadingMsg = 'Preparing email...';

      quoteService.getEmailTemplate(this.id).then((x) => {
        this.loading = false;
        this.showEmailQuotePopup = true;
        this.emailTemplate = x;
      });
    },
    bookShipment() {
      const saveShipmentRequest = new SaveShipmentRequest();
      saveShipmentRequest.mapQuoteToShipment(this.quote);
      saveShipmentRequest.userId = this.quote.userId;
      saveShipmentRequest.accountId = this.quote.accountId;

      this.loading = true;
      this.loadingMsg = 'Preparing shipment...';

      pendingOrderService
        .create(saveShipmentRequest)
        .then(this.finishCreatingShipment)
        .catch((x) => {
          console.error(x);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    finishCreatingShipment(x: SavePendingOrderResponse) {
      const justCreatedOrderId = x.orderId;
      this.loading = false;
      if (justCreatedOrderId) {
        miscService.goToPage(`/customer/shipment/${justCreatedOrderId}/edit`);
      }
    },
    emailSent() {
      this.snackbarText = 'Email sent successfully';
      this.snackbar = true;
    },
  },
  computed: {
    currency() {
      return this.quote?.currency ?? 'USD';
    },
    id() {
      return routeService.getValue(this, 'quoteId');
    },
    totalCharge() {
      return this.formatMoney(
        (this.quote.fuelCharge ?? 0) + (this.quote.accCharge ?? 0)
      );
    },
    totalWeight() {
      let weight = 0;
      for (let i = 0; i < this.quote.pieces.length; i++)
        weight += this.quote.pieces[i].weight;

      return weight;
    },
    path() {
      const logo = carrierLogoService.getLogoPath(
        this.quote.carrierName
      ) as Logo;

      return logo != null ? logo.src : '';
    },
    stops() {
      const stops = this.quote.stopsCount;
      return stops ? stops : 1;
    },
    actPickup() {
      return this.quote.actPickupDate
        ? this.formatDate(this.quote.actPickupDate)
        : 'Not Available';
    },
    actDelivery() {
      return this.quote.actDeliveryDate
        ? this.formatDate(this.quote.actDeliveryDate)
        : 'Not Available';
    },
    pro() {
      return this.quote.proNumber ? this.quote.proNumber : 'N/A';
    },
    po() {
      return this.quote.poNumber ? this.quote.poNumber : 'N/A';
    },
    transitDays() {
      return Number(this.quote.transitDays);
    },
    distributionMethod() {
      return miscService.distributionMethod(this.quote.chargeType);
    },
    eta() {
      return this.transitDays + ' Day' + (this.transitDays > 1 ? 's' : '');
    },
    origAddress() {
      return [
        this.quote.copmany,
        '',
        this.quote.origCity,
        this.quote.origState,
        this.quote.origZip,
        this.quote.origCountry,
      ];
    },
    destAddress() {
      return [
        '',
        '',
        this.quote.destCity,
        this.quote.destState,
        this.quote.destZip,
        this.quote.destCountry,
      ];
    },
    base() {
      const baseRate = this.quote.additionalServices?.find(
        (x) => x.accChargeId == 23
      );
      if (baseRate) {
        return baseRate.sellCharge;
      }

      return null;
    },
    fuel() {
      const fuel = this.quote.additionalServices?.find(
        (x) => x.accChargeId == 8
      );
      if (fuel) {
        return fuel.sellCharge;
      }

      return null;
    },
    additionalCharges() {
      return this.quote.additionalServices?.filter(
        (x) => x.accChargeId != 8 && x.accChargeId != 23
      );
    },
    total() {
      let total = 0;
      if (this.base) {
        total += this.base;
      }

      if (this.fuel) {
        total += this.fuel;
      }

      if (this.additionalCharges) {
        this.additionalCharges.forEach((x) => (total += x.sellCharge));
      }

      return total;
    },
    destAddressInline() {
      let address = '';
      if (this.quote.destCity) {
        address += this.quote.destCity;
      }

      if (this.quote.destState) {
        address += ', ' + this.quote.destState;
      }

      if (this.quote.destZip) {
        address += ' ' + this.quote.destZip;
      }

      if (this.quote.destCountry) {
        address += ' ' + this.quote.destCountry;
      }

      return address;
    },
    estimatedDeliveryDate() {
      if (this.holidays.length && this.transitDays) {
        const pickupDate = moment(this.quote.createdDate);

        let daysToAdd = 0;
        for (let i = 0; i < this.transitDays; i++) {
          const date = moment(this.quote.createdDate).add(i, 'days');
          if (this.isHoliday(date) || this.isWeekend(date)) {
            daysToAdd++;
          }
        }

        const date = pickupDate.add(daysToAdd + this.transitDays, 'days');
        return this.formatDate(date.format('MM/DD/yyyy'));
      }

      return this.formatDate(this.quote.createdDate);
    },
    accessorials() {
      const items = this.quote.additionalServices;
      if (items) {
        return items.filter(
          (item, index, self) =>
            self.findIndex(
              (t) =>
                t.accChargeId === item.accChargeId &&
                t.accChargeId === item.accChargeId
            ) === index
        );
      }

      return [];
    },
  },
});
